export function sizeFormat(size) {
    var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export function loadingOverlay(elem, enable) {
    var $elem = $(elem);
    if(enable){
        $elem.append('<div class="loading-overlay"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
        $elem.addClass('loading');
    }
    else {
        $elem.find('.loading-overlay').remove();
        $elem.removeClass('loading');
    }
}

export function scrollToElement(elem) {
    var $elem = $(elem);
    if($elem.length){
        var headerHeight = $('#header').height() + $('#wpadminbar').height();
        $('html, body').animate({
            scrollTop: $elem.offset().top - headerHeight
        }, 1000);
    }
}

// Bootstrap form validation
export function formValidation(event) {
    if (!this.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
    }

    this.classList.add('was-validated');
}